import {EActionStatus} from '@app/shared/enums/action-status.enum';
import {createReducer, on} from '@ngrx/store';
import {IMultiSelectState, ISelectState} from '../../models/dynamic-form.model';
import {
  multiSelectAction,
  multiSelectEffectError,
  multiSelectEffectFailure,
  multiSelectEffectSuccess,
  selectAction,
  selectEffectError,
  selectEffectFailure,
  selectEffectSuccess,
} from './dynamic-form.actions';

const initialMultiSelectState: IMultiSelectState = {
  status: EActionStatus.Initial,
  successResponse: null,
  failureReason: '',
  errorMessage: '',
  formControlName: '',
};
export const multiSelectReducer = createReducer(
  initialMultiSelectState,
  on(multiSelectAction, (state, {formControlName}) => ({
    ...state,
    status: EActionStatus.Pending,
    formControlName: formControlName,
  })),
  on(multiSelectEffectSuccess, (state, {response, formControlName}) => ({
    ...state,
    status: EActionStatus.Success,
    successResponse: response,
    formControlName: formControlName,
  })),
  on(multiSelectEffectFailure, (state, {reason, formControlName}) => ({
    ...state,
    status: EActionStatus.Failure,
    failureReason: reason,
    formControlName: formControlName,
  })),
  on(multiSelectEffectError, (state, {error, formControlName}) => ({
    ...state,
    status: EActionStatus.Error,
    errorMessage: error,
    formControlName: formControlName,
  }))
);

const initialSelectState: ISelectState = {
  status: EActionStatus.Initial,
  successResponse: null,
  failureReason: '',
  errorMessage: '',
  formControlName: '',
};
export const selectReducer = createReducer(
  initialSelectState,
  on(selectAction, (state, {formControlName}) => ({
    ...state,
    status: EActionStatus.Pending,
    formControlName: formControlName,
  })),
  on(selectEffectSuccess, (state, {response, formControlName}) => ({
    ...state,
    status: EActionStatus.Success,
    successResponse: response,
    formControlName: formControlName,
  })),
  on(selectEffectFailure, (state, {reason, formControlName}) => ({
    ...state,
    status: EActionStatus.Failure,
    failureReason: reason,
    formControlName: formControlName,
  })),
  on(selectEffectError, (state, {error, formControlName}) => ({
    ...state,
    status: EActionStatus.Error,
    errorMessage: error,
    formControlName: formControlName,
  }))
);
